import React from "react";
import CommonInput from "../../../components/forms/CommonInput";
import {
  handleChange,
  handleChangeNameValue,
} from "../../../helpers/handleFormChanges";
import CommonSelect from "../../../components/forms/CommonSelect";
import CommonInputValor from "../../../components/forms/CommonInputValor";
import CommonButton from "../../../components/buttons/CommonButton";
import CommonDataTable from "../../../components/Datatable/CommonDataTable";
import TabHelper from "../../../helpers/TabHelper";
import PropTypes from "prop-types";
import useTipos from "../../../hooks/common/useTipos";

function DadosContratuais({
  valuesHook,
  jornadas,
  jornada,
  togNovaJornadaModal,
  tabHook,
  salvaColaborador,
  editavel,
  retornar,
  salarioEditavel = false,
  admissao = false,
}) {
  const { values, setValues } = valuesHook;
  const { tabAtual, setTabAtual } = tabHook;
  const tiposContratoTrabalho = useTipos("tipos_contrato_trabalho");
  const tiposHorasSemanais = useTipos("tipos_horas_semanais");

  const colunas = React.useMemo(
    () => [
      {
        Header: "Dia da semana",
        disableSortBy: true,
        accessor: "dia_semana",
      },
      {
        Header: "Entrada",
        disableSortBy: true,
        accessor: "entrada",
      },
      {
        Header: "Saída",
        disableSortBy: true,
        accessor: "saida",
      },
      {
        Header: "Intervalo (min)",
        disableSortBy: true,
        accessor: "intervalo",
      },
    ],
    []
  );

  return (
    <>
      <div className="row">
        <div className="col-lg-5 mb-3">
          <CommonInput
            id="cargo"
            label="Cargo"
            onChange={(e) => handleChange(e, values, setValues)}
            value={values.cargo}
            required
            disabled={!editavel}
          />
        </div>
        <div className="col-lg-3 mb-3">
          <CommonSelect
            id="categoria"
            label="Categoria do trabalhador"
            onChange={(e) => handleChange(e, values, setValues)}
            value={values.categoria}
            data={tiposContratoTrabalho.map((contratoTrabalho) => ({
              text: contratoTrabalho.valor,
              id: contratoTrabalho.chave,
            }))}
            required
            disabled={!editavel}
          />
        </div>
        <div className="col-lg-4 mb-3">
          <CommonInputValor
            id="salario"
            label="Salário"
            onChange={(e) => {
              handleChangeNameValue(
                "salario",
                e.target.value,
                values,
                setValues
              );
            }}
            value={values.salario}
            required
            disabled={!salarioEditavel}
          />
        </div>
      </div>
      <div className="row">
        <div className="col-md-6 mb-3">
          <CommonSelect
            id="uid_jornada"
            label="Jornada de trabalho"
            onChange={(e) => handleChange(e, values, setValues)}
            value={values.uid_jornada}
            data={Object.keys(jornadas).map((id) => ({
              text: `${
                (tiposHorasSemanais &&
                  tiposHorasSemanais.find(
                    (horasSemanais) =>
                      parseInt(horasSemanais.chave) ===
                      parseInt(jornadas[id].horas_totais)
                  )?.valor) ||
                ""
              } - ${jornadas[id].descricao}`,
              id: jornadas[id].uid,
            }))}
            disabled={!editavel}
          />
        </div>
        {editavel ? (
          <div className="col-md-6 mb-3" style={{ alignSelf: "end" }}>
            <CommonButton color="primary" onClick={togNovaJornadaModal}>
              Cadastrar jornada
            </CommonButton>
          </div>
        ) : null}
      </div>
      <div className="row">
        <div className="col-lg-5 mb-3">
          <CommonDataTable
            colunas={colunas}
            linhas={jornada}
            filtro={false}
            pagination={false}
          />
        </div>
      </div>
      <div className="row mb-3 mx-0">
        <div className="d-flex flex-column flex-md-row align-items-center justify-content-between gap-1">
          <CommonButton
            onClick={() => {
              TabHelper.trocarTab(tabAtual, setTabAtual, -1);
            }}
            color="primary"
          >
            Anterior
          </CommonButton>
          <div className="d-flex flex-column flex-md-row align-items-center gap-1">
            <CommonButton onClick={retornar} color="danger">
              Voltar
            </CommonButton>
            {editavel ? (
              <CommonButton onClick={salvaColaborador} color="success">
                {admissao ? "Salvar rascunho" : "Salvar"}
              </CommonButton>
            ) : null}
            <CommonButton
              onClick={() => {
                TabHelper.trocarTab(tabAtual, setTabAtual, 1);
              }}
              color="primary"
            >
              Próximo
            </CommonButton>
          </div>
        </div>
      </div>
    </>
  );
}

DadosContratuais.propTypes = {
  valuesHook: PropTypes.shape({
    values: PropTypes.object.isRequired,
    setValues: PropTypes.func.isRequired,
  }).isRequired,
  jornadas: PropTypes.object.isRequired,
  jornada: PropTypes.array.isRequired,
  togNovaJornadaModal: PropTypes.func.isRequired,
  tabHook: PropTypes.shape({
    tabAtual: PropTypes.string.isRequired,
    setTabAtual: PropTypes.func.isRequired,
  }).isRequired,
  salvaColaborador: PropTypes.func.isRequired,
  editavel: PropTypes.bool.isRequired,
  retornar: PropTypes.func.isRequired,
  salarioEditavel: PropTypes.bool,
  admissao: PropTypes.bool,
};

DadosContratuais.defaultProps = {
  salarioEditavel: false,
  admissao: false,
};

export default DadosContratuais;
